export default Object.freeze({
  PROMO_VALIDATION_FAILED: 'PROMO_VALIDATION_FAILED',
  KEY: {
    REGISTER: 'REGISTER',
  },
})
